import { Map, AdvancedMarker, APIProvider } from "@vis.gl/react-google-maps";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useListingsContext } from "../../context/ListingsContext"
import { AuthContext } from "../../context/AuthContext";
import { LoginModalContext } from "../../context/LoginModalContext";
import { useState } from "react";
import AddressAutocomplete from "../helperComponents/AddressAutocomplete";

const MapContainer = () => {
    const { currentUser } = useContext(AuthContext)
    const { setLoginModalOpen } = useContext(LoginModalContext)

    const [activeListingPreview, setActiveListingPreview] = useState(null)
    
    const REACT_APP_GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY

    const center = currentUser && currentUser.coordinates ? currentUser.coordinates : { lat: 40.7228, lng: -73.9760 }
    const listings = useListingsContext().listings

    const onMarkerClick = (e) => {
        const listingId = e.domEvent.target.getAttribute("listingid")
        console.log(listingId)
        setActiveListingPreview(listingId)
    }

    const handleCloseClick = (e) => {
        setActiveListingPreview(null)
    }
    
    const navigate = useNavigate()
    const navigateToListing = (e) => {
        const listingId = e.target.getAttribute("listingId")

        navigate(`/item/${listingId}`, {state:{listing_id: listingId}})
        
        // currentUser ? 
        // navigate(`/item/${listingId}`, {state:{listing_id: listingId}}) :
        // setLoginModalOpen(true)
    }

    return (
        <div className="mapdiv">
            <label className="map-toggle">
                <input type="checkbox" id="map-toggle" />
            </label>
            <div className="map" id="map">
                <APIProvider apiKey={REACT_APP_GOOGLE_MAPS_KEY}>
                    <Map defaultCenter = {center} defaultZoom={13} mapId="e6bb73b7d2d2118a5273a659" minZoom={13} maxZoom={14.6} disableDefaultUI="true">
                        {
                            listings ? 
                            listings.map((listing, i) => (
                                <AdvancedMarker
                                    key={`advanced-market-${i}`}
                                    position={listing.markerCoordinates}
                                    onClick={onMarkerClick}
                                >
                                    <div className="map-marker" listingid={listing.listing_id}>
                                    </div>
                                    <div className="map-listing-preview" listingid={listing.listing_id} 
                                      style={{display: listing.listing_id === activeListingPreview ? "flex" : "none"}}
                                    >
                                        <div onClick={handleCloseClick} className="x-delete-button x-button-preview">
                                            <div className="x-container"></div>
                                        </div>
                                        <div className="preview-info-container" listingid={listing.listing_id} onClick={navigateToListing}>
                                            <div className="image-preview-div" listingid={listing.listing_id}>
                                                <img className="map-listing-preview-image" src={listing.image_urls[0]} listingid={listing.listing_id}></img>
                                            </div>
                                            <div className="map-listing-preview-title" listingid={listing.listing_id}> {listing.title} </div>
                                            <div className="map-listing-preview-price" listingid={listing.listing_id}> ${listing.price} </div>
                                        </div>
                                    </div>
                                </AdvancedMarker>
                            ))
                            : <></>
                        }
                    
                    </Map>
                </APIProvider>
            </div>
        

        </div>
    )
}

export default MapContainer